import { createFileRoute } from '@tanstack/react-router'
import { TopicsPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/community/themen/')({
  loader: () => loadPageData({ data: { kind: 'topics', locale: 'de' } }),
  head: () => staticRouteHead('communityTopics', 'de'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <TopicsPage />
    </CatalogProvider>
  )
}
